export default __webpack_public_path__ + "static/media/GOTG.0bb4121f.webp";